import GET_ARTICLES from '../plugins/getArticles'

const [ w, d ] = [ window, document ]

export default function HOME() {

  w.load['movBlock_ready'] = new $.Deferred

  w.jQuery = $

  const getTicker = opt => $.getJSON("/asset/api/getArticles/", {
    content: opt.content || 'news',
    post_per_page: opt.amount || 1
  })
  const getCats = opt => $.getJSON('/asset/api/getCategories/', {
    content: opt.content || 'news'
  })

  $(() => {
    /****************************
     * movie background
     */
    $.when(
      w.load['mainvisual'],
      w.load['movBlock_ready'],
      $.getScript('/asset/js/vendor/jquery.mb.YTPlayer.min.js')
    ).done(()=>{
      const $MV = $('[data-plugin="ytplayer"]')
      const param = id => `{
        videoURL: '${id}',
        containment: 'body',
        mute: true,
        showControls: false,
        autoPlay: true,
        useOnMobile: true,
        showYTLogo: false,
        abundance: 0.07,
        stopMovieOnBlur: false,
        loop: true,
        startAt: 0,
        anchor: 'center,center',
        quality: 'default'
      }`.replace(/\n|\s/g,'')
      $MV.attr('data-property',param('G2Q3WEaaVuY'));
      $MV.YTPlayer()
      $MV.YTPPlay()
    })

    // scroll ボタン
    w.load['mainvisual'].done( () => {
      // スクロールボタンをクリックで画面の高さ分スクロール
      $('.p-mainvisual__scroll').on('click',()=>{
        const scrollTop = parseInt( $(w).innerHeight() ) - 136
        $('body,html').animate({ scrollTop },'fast','easeInOutExpo')
        return false
      })
    })

    // ticker取得
    const applyTicker = () => {
      const applyHtml = ( obj, data ) => {
        const dateObj = new Date( parseInt( data.date ) * 1000 )
        const [ Y, m, d ] = [ dateObj.getFullYear(), dateObj.getMonth() + 1, dateObj.getDate() ]
        data.date = `${Y}.${ ( '00' + m ).slice( -2 ) }.${( '00' + d ).slice( -2)}`
        obj.href = data.href
        obj.innerHTML = `
          <span class="cat">${data.category.name}</span>
          <span class="date">${ data.date }</span>
          <span class="title">${data.title}</span>`
      }
      $('[data-plugin="getTicker"]').each( (i,obj) => {

        $.when(
          getTicker( obj.dataset ),
          getCats( obj.dataset )
        ).done( ( data, cats ) => {
          data = data[0][0]
          cats = cats[0]
          data.category = cats.filter( o => o.id == data.category )[0];
          if(!data.category) data.category = {id:'0',name:'その他',href:`/${obj.dataset.content}/?mode=list&cat=0`};
          applyHtml( obj, data )
        })
      })
    }
    w.load['home-block-about'].done( applyTicker )

    // Cases
    const applyCaseArticles = () => {
      GET_ARTICLES('.p-block-cases__list[data-plugin="getArticles"]',{
        makeItem( item ){
          return $(`
            <li class="p-block-cases__item">
              <a href="${item.href}" class="p-block-cases__item-link">
                <figure class="p-block-cases__item-img">
                  <div class="p-block-cases__item-imgInner" style="background-image:url(${item.thumb});"><img src="${item.thumb}" alt="${item.title.str_truncate(29)}"></div>
                </figure>
                <div class="p-block-cases__body">
                  <span class="cate">${item.category.name}</span>
                  <h4 class="title">${item.title.str_truncate(29)}</h4>
                </div>
              </a>
            </li>
          `)[0]
        }
      })
    }
    w.load['home-block-cases'].done( applyCaseArticles )

    // News
    const applyNewsArticles = () => {
      GET_ARTICLES('.p-block-news__list[data-plugin="getArticles"]',{
        makeItem( item ){
          return $(`
            <li class="p-block-news__item">
              <a href="${item.href}">
                <p class="date">${item.date}</p>
                <span class="cate">${item.category.name}</span>
                <span class="title ${item.is_new? 'is-new':''}">${item.title}</span>
              </a>
            </li>
          `)[0]
        }
      })
    }
    w.load['home-block-news'].done( applyNewsArticles )

    
    // Movie
    $.when( w.load['home-block-movie'] ).then( () => {

      const $container = $('.p-block-movie').hide()

      let makeItem = item => {
        let parser = new DOMParser
        let itemBody =  parser.parseFromString( item.body || item.body.trim(), 'text/html' )
        let itemIframe = itemBody.querySelector('iframe')
        let videoId = ""
        let playerDOM = d.createElement( 'div' )
        let block

        if ( $container.is(':hidden') ) $container.show() 
        
        if ( itemIframe != null ) {
          videoId = itemIframe.src.replace( /^https?:\/\/www\.youtube\.com\/embed\/([^/?]+)(.*)?$/, '$1' )
        }

        block = parser.parseFromString(
          `<li class="p-block-movie__item">
            <a href="${item.href}">
              <figure class="p-block-movie__image">
                <div class="p-block-movie__player" style="background-image:url(${item.thumb});">
                  ${videoId == "" ? `<img src="${item.thumb}" alt="${item.title}"/>` : "" }
                </div>
                <figcaption class="p-block-movie__body">
                  <span class="date">${item.date}</span>
                  <span class="subject">${item.title}</span>
                </figcaption>
              </figure>
            </a>
          </li>`,
          'text/html').querySelector('li')

        $(d).on('YTAPIReady', () => {
          if ( videoId != "" ) {
            block.querySelector('.p-block-movie__player').appendChild(playerDOM)

            let player = new YT.Player( playerDOM, {
              width: '640',
              height: '360',
              videoId,
              playerVars: { 'rel' : 0, 'showinfo' : 0 }
            })
          }

        })


        return block
      }
      GET_ARTICLES('.p-block-movie__list[data-plugin="getArticles"]', { makeItem })
        .then( () => w.load['movBlock_ready'].resolve() )
    })

  });

}
